export const PF = 'add-edit-product-category';
